import React from "react";
import { Link } from "react-router-dom";
import "./ThankYou.css";

const HeartIcon = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 24 24"
    fill="var(--amber)"
    aria-hidden="true"
  >
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
  </svg>
);

const ShareIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <path d="M8.59 13.51l6.83 3.98M15.41 6.51L8.59 10.49" />
  </svg>
);

export default function ThankYou() {
  return (
    <main className="thankyou-page">
      <section className="thankyou-hero" aria-label="Thank you for your donation">
        <div className="container thankyou-hero-inner">
          <div className="thankyou-icon">
            <HeartIcon />
          </div>
          <span className="eyebrow" style={{ color: "var(--amber-light)" }}>
            Payment Received
          </span>
          <h1>Thank You for Your Generosity</h1>
          <p>
            Your donation has been received and is already on its way to
            making a real difference — a meal, a school fee, a moment of
            dignity for someone who needs it.
          </p>
        </div>
      </section>

      <section className="section thankyou-body-section" aria-labelledby="thankyou-next-heading">
        <div className="container">
          <div className="thankyou-card">
            <h2 id="thankyou-next-heading">What Happens Next</h2>
            <div className="divider" />
            <ul className="thankyou-steps">
              <li>
                <span className="thankyou-step-num">1</span>
                <div>
                  <h3>Confirmation Email</h3>
                  <p>
                    PayFast will email you a payment confirmation shortly. If
                    you don't see it within a few minutes, please check your
                    spam folder.
                  </p>
                </div>
              </li>
              <li>
                <span className="thankyou-step-num">2</span>
                <div>
                  <h3>Your Gift Goes to Work</h3>
                  <p>
                    Your donation is allocated directly to the cause you
                    selected and is reflected in our programme reporting,
                    with full transparency on how every rand is used.
                  </p>
                </div>
              </li>
              <li>
                <span className="thankyou-step-num">3</span>
                <div>
                  <h3>Stay Connected</h3>
                  <p>
                    Follow our journey, see the real impact of donations like
                    yours, and meet the families and communities you're
                    supporting.
                  </p>
                </div>
              </li>
            </ul>

            <div className="thankyou-actions">
              <Link to="/our-impact" className="btn btn-primary">
                See Our Impact
              </Link>
              <Link to="/gallery" className="btn btn-outline-green">
                View the Gallery
              </Link>
            </div>
          </div>

          <div className="thankyou-share">
            <ShareIcon />
            <p>
              Know someone who'd want to help too? Share the Food and
              Nutrition Foundation with them.
            </p>
          </div>
        </div>
      </section>

      <section className="cta-band" aria-label="Continue supporting">
        <div className="container cta-band-inner">
          <div>
            <h2>Want to Do Even More?</h2>
            <p>Consider becoming a monthly donor or volunteering your time.</p>
          </div>
          <div className="cta-band-actions">
            <Link to="/donate" className="btn btn-primary btn-lg">
              Give Again
            </Link>
            <Link to="/get-involved" className="btn btn-secondary">
              Get Involved
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
